module.exports = __webpack_public_path__ + "static/media/3.057cbc50.jpg";